'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode, SyntheticEvent, useEffect, useId, useState } from 'react';
import { cn } from '@ncai-axe/react-ui-v3';
import ChevronDownIcon from '@ncai-axe/react-ui-v3/assets/svg/icons/ic_chevron_fill_down.svg';
import styles from './styles.module.scss';
interface IAccordionListItem {
  useArrow?: boolean;
  header?: ReactNode;
  content?: ReactNode;
  children?: ReactNode;
  changeHandler?: (e: SyntheticEvent) => void;
  expendState?: boolean;
  className?: string;
  unmountOnCollapse?: boolean;
  keepMountedOnCollapse?: boolean;
}
export const AccordionListItem = t0 => {
  const $ = _c(30);
  const {
    useArrow: t1,
    changeHandler,
    header,
    content,
    children,
    expendState: t2,
    className,
    unmountOnCollapse: t3,
    keepMountedOnCollapse: t4
  } = t0;
  const useArrow = t1 === undefined ? true : t1;
  const expendState = t2 === undefined ? false : t2;
  const unmountOnCollapse = t3 === undefined ? false : t3;
  const keepMountedOnCollapse = t4 === undefined ? false : t4;
  const [isExpend, setExpend] = useState(expendState);
  const [hasExpandedOnce, setHasExpandedOnce] = useState(expendState);
  const id = useId();
  let t5;
  if ($[0] !== changeHandler || $[1] !== isExpend) {
    t5 = e => {
      setExpend(!isExpend);
      if (typeof changeHandler === "function") {
        changeHandler(e);
      }
    };
    $[0] = changeHandler;
    $[1] = isExpend;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const handleChange = t5;
  let t6;
  let t7;
  if ($[3] !== expendState) {
    t6 = () => {
      setExpend(expendState);
    };
    t7 = [expendState];
    $[3] = expendState;
    $[4] = t6;
    $[5] = t7;
  } else {
    t6 = $[4];
    t7 = $[5];
  }
  useEffect(t6, t7);
  let t8;
  let t9;
  if ($[6] !== isExpend) {
    t8 = () => {
      if (isExpend) {
        setHasExpandedOnce(true);
      }
    };
    t9 = [isExpend];
    $[6] = isExpend;
    $[7] = t8;
    $[8] = t9;
  } else {
    t8 = $[7];
    t9 = $[8];
  }
  useEffect(t8, t9);
  const shouldRenderContent = !unmountOnCollapse || isExpend || keepMountedOnCollapse && hasExpandedOnce;
  const t10 = isExpend && styles.expend;
  let t11;
  if ($[9] !== className || $[10] !== t10) {
    t11 = cn(styles.accordionListItem, t10, className);
    $[9] = className;
    $[10] = t10;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== handleChange || $[13] !== id) {
    t12 = <input id={id} type="checkbox" onChange={handleChange} />;
    $[12] = handleChange;
    $[13] = id;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== useArrow) {
    t13 = useArrow && <ChevronDownIcon width={16} height={16} />;
    $[15] = useArrow;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== header || $[18] !== id || $[19] !== t13) {
    t14 = <label htmlFor={id}>{header}{t13}</label>;
    $[17] = header;
    $[18] = id;
    $[19] = t13;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== t12 || $[22] !== t14) {
    t15 = <div className={styles.header}>{t12}{t14}</div>;
    $[21] = t12;
    $[22] = t14;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  const t16 = shouldRenderContent && (children || content);
  let t17;
  if ($[24] !== t16) {
    t17 = <div className={styles.content}><div className={styles.contentInner}>{t16}</div></div>;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t11 || $[27] !== t15 || $[28] !== t17) {
    t18 = <li className={t11}>{t15}{t17}</li>;
    $[26] = t11;
    $[27] = t15;
    $[28] = t17;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  return t18;
};